<div class="right-side p-5">
  <div class="row justify-content-end mb-1">

    <form [formGroup]="ReverseBS">
      <div class="col-lg-8">
        <mat-card-content class="p-24">
          <h2>Reverse Buyer Seller Details</h2>
        </mat-card-content>
      </div>
      <div class="text-end">

        <button type="button" (click)="NewBuyer()" class="btn btn-sm btn-success me-2 mb-2">
          <i class="bi bi-plus"></i> New Buyer Requirement
        </button>
      </div>

      <div class="section">

        <div class="row">

          <div class="mt-1">
            <div class="search">
              <div class="text-end mb-2">
                <button (click)="exportToExcel()" type="button" class="btn btn-sm btn-success me-2"><i class="bi bi-file-earmark-excel"></i> Export To Excel</button>

                <!--<button (click)="exportToPDF()" type="button" class="btn btn-sm btn-primary">Export to PDF</button>-->
              </div>

              <div class="col-lg-7 col-sm-12">
                <div class="search-container">
                  <mat-form-field class="search-input w-75" appearance="outline">
                    <mat-label>Search</mat-label>
                    <input matInput formControlName="searchControl" />
                  </mat-form-field>
                  <button class="btn btn-outline-secondary p-2 mx-1 search-button" type="submit" (click)="onSearchClick(ReverseBS.get('searchControl')?.value ?? '')" id="btnSearch">
                    <i class="bi bi-search fs-4"></i>
                  </button>
                  <button class="btn btn-outline-secondary p-2" type="reset" (click)="resetPage()" id="btnReset">
                    <i class="bi bi-arrow-clockwise fs-4"></i>
                  </button>
                </div>
                <div *ngIf="ReverseBS.get('searchControl')?.invalid && (ReverseBS.get('searchControl')?.touched || ReverseBS.get('searchControl')?.dirty)">
                  <small *ngIf="ReverseBS.get('searchControl')?.errors?.['pattern']" class="text-danger">
                    Invalid search term.
                  </small>
                </div>

              </div>

            </div>
            <!--<div class="table-responsive">
    <table class="table table-striped table-bordered table-hover" style="font-size:small;">
      <thead>
        <tr>
          <th>Sr. No</th>
          <th (click)="sort('UdyamRegistrationNumber')" [class.sorted]="sortColumn === 'UdyamRegistrationNumber'">
            {{ sortColumn === 'UdyamRegistrationNumber' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }} Udyam Registration Number
          </th>
          <th (click)="sort('Name')" [class.sorted]="sortColumn === 'Name'">
            {{ sortColumn === 'Name' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }} Name
          </th>
          <th (click)="sort('NameOfEnterprise')" [class.sorted]="sortColumn === 'NameOfEnterprise'">
            {{ sortColumn === 'NameOfEnterprise' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }} Name of Enterprise
          </th>
          <th (click)="sort('Email')" [class.sorted]="sortColumn === 'Email'">
            {{ sortColumn === 'Email' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }} Email
          </th>
          <th (click)="sort('OwnersMobileNumber')" [class.sorted]="sortColumn === 'OwnersMobileNumber'">
            {{ sortColumn === 'OwnersMobileNumber' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }} Owner's Mobile Number
          </th>
          <th (click)="sort('HSNCode')" [class.sorted]="sortColumn === 'HSNCode'">
            {{ sortColumn === 'HSNCode' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }} HSN Code
          </th>-->
            <!--<th>Action</th>-->
            <!--</tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of dataSource; index as i">
      <td class="text-center">{{ item.rowNum }}</td>
      <td class="text-center">{{ item.udyamRegistrationNumber }}</td>
      <td class="text-center">{{ item.name }}</td>
      <td class="text-center">{{ item.nameOfEnterprise }}</td>
      <td class="text-center">{{ item.email }}</td>
      <td class="text-center">{{ item.ownersMobileNumber }}</td>
      <td class="text-center">{{ item.hsnCode }}</td>-->
            <!--<td class="text-center">
    <button (click)="onAction(item)" class="btn btn-primary btn-sm">
      <i class="fa fa-cog"></i> Action
    </button>
  </td>-->
            <!--</tr>
      </tbody>
    </table>
  </div>

  <mat-paginator #paginator
                 class="demo-paginator"
                 (page)="onPageChange($event)"
                 [length]="length"
                 [pageSize]="pageSize"
                 [disabled]="disabled"
                 [showFirstLastButtons]="showFirstLastButtons"
                 [pageSizeOptions]="pageSizeOptions"
                 [hidePageSize]="hidePageSize"
                 [pageIndex]="pageIndex"
                 aria-label="Select page">
  </mat-paginator>-->

            <div class="table-responsive">
              <table mat-table [dataSource]="dataSource" class="table table-striped table-bordered table-hover" matTableResponsive matSortActive="InterventionName" matSort matSortDirection="desc" matSortDisableClear>
                <ng-container matColumnDef="Sr.No">
                  <th mat-header-cell *matHeaderCellDef>Sr. No.</th>
                  <td mat-cell *matCellDef="let el"> {{el.rowNum}} </td>
                </ng-container>
                <ng-container matColumnDef="udyamRegistrationNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Udyam Registration Number </th>
                  <td mat-cell *matCellDef="let el"> {{el.udyamRegistrationNumber}} </td>
                </ng-container>
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                  <td mat-cell *matCellDef="let el"> {{el.name}} </td>
                </ng-container>
                <ng-container matColumnDef="nameOfEnterprise">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Name of Enterprise </th>
                  <td mat-cell *matCellDef="let el"> {{el.nameOfEnterprise}} </td>
                </ng-container>
                <ng-container matColumnDef="email">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
                  <td mat-cell *matCellDef="let el"> {{el.email}} </td>
                </ng-container>
                <ng-container matColumnDef="ownersMobileNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Owner's Mobile Number </th>
                  <td mat-cell *matCellDef="let el"> {{el.ownersMobileNumber}} </td>
                </ng-container>
                <ng-container matColumnDef="hsnCode">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>HSN Code </th>
                  <td mat-cell *matCellDef="let el"> {{el.hsnCode}} </td>
                </ng-container>
                

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                Row shown when there is no matching data.
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="4">No data matching the filter</td>

                </tr>
              </table>

            </div>
            <mat-paginator #paginator
                           class="demo-paginator"
                           (page)="onPageChange($event)"
                           [length]="length"
                           [pageSize]="pageSize"
                           [showFirstLastButtons]="showFirstLastButtons"
                           [pageSizeOptions]="pageSizeOptions"
                           [hidePageSize]="hidePageSize"
                           [pageIndex]="pageIndex"
                           aria-label="Select page">
            </mat-paginator>
          </div>
        </div>
      </div>
    </form>

  </div>
</div>
